module.exports = __webpack_public_path__ + "img/icon_complete.763a4d00.png";